import React from "react";
import { teamMember1, teamMember2 } from "../../../../../images";

const TeamSection = () => {
  const team = [
    {
      name: "Saurabh Jain",
      role: "Strategy & Growth",
      img: teamMember1, // Replace with real image
    },
    {
      name: "Shubham",
      role: "Operations & Insights",
      img: teamMember2, // Replace with real image
    },
  ];

  return (
      <div className="team-section">
        <div className="container">
          <h1 className="about-sub-heading text-center mb-5">Meet the Team</h1>
          
          <div className="row justify-content-center g-4">
            {team.map((member, index) => (
              <div key={index} className="col-lg-4 col-md-6 col-sm-12">
                <div className="team-card">
                  <div className="card-gradient">
                    <img src={member.img} alt={member.name} className="img-fluid"></img>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
  );
};

export default TeamSection;
